import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React, { ReactNode, useState } from 'react';

import { UploadFileExtension } from 'packages/manualDataTapeUploads/ui/UploadDataTapeDropzone';
import { UploadDataTapeForm } from 'packages/manualDataTapeUploads/ui/UploadDataTapeForm';

type Props = {
  allowedExtensions: UploadFileExtension[];
  modalHeaderText?: string;
  handleFile: (file: File) => Promise<void>;
  children: ReactNode;
};
export const FileUploadButton = ({
  children,
  modalHeaderText,
  handleFile,
  allowedExtensions,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);

  return (
    <Box
      onClick={(e) => {
        setIsOpen(true);
        // stop event propagation
        e.stopPropagation();
      }}
      width="100%"
    >
      {/* button for open form is supplied by caller */}
      {children}

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent padding="20px" width="auto" minW="550px">
          <ModalHeader>{modalHeaderText ?? 'Upload Tape'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <UploadDataTapeForm
              allowedExtensions={allowedExtensions}
              onClose={onClose}
              handleFile={handleFile}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
